export default "__VITE_ASSET__4JXOte$4__"